import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function NotificationsPriorityIcon({ className }: IconProps) {
  return (
    <svg
      width="66"
      height="77"
      viewBox="0 0 66 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1378)">
        <path
          d="M41.5953 65.368C41.5953 71.8042 36.3872 76.9999 29.9881 76.9999C23.5889 76.9999 18.3809 71.7808 18.3809 65.368C18.3809 58.9552 23.5889 53.7361 29.9881 53.7361C36.3872 53.7361 41.5953 58.9552 41.5953 65.368Z"
          fill="#00C4B3"
        />
        <path
          d="M45.7048 19.6361C45.7048 10.9531 38.6751 3.88501 29.9872 3.88501C21.2993 3.88501 14.2695 10.9297 14.2695 19.6361C14.2695 28.3425 21.2993 35.3871 29.9872 35.3871C38.6751 35.3871 45.7048 28.3425 45.7048 19.6361Z"
          fill="#00416B"
        />
        <path
          d="M53.7156 62.8637H6.25911C2.82599 62.8637 0.0234375 60.0786 0.0234375 56.6382V51.6765H59.9512V56.6382C59.9512 60.0786 57.1487 62.8872 53.7156 62.8872"
          fill="#00416B"
        />
        <path
          d="M50.3524 29.8638C47.4331 27.1489 45.7049 23.4043 45.7049 19.4255V19.1681C45.7049 17.6936 44.5138 16.5 43.0425 16.5H16.9554C15.4841 16.5 14.293 17.6936 14.293 19.1681V19.4255C14.293 23.4277 12.518 27.1723 9.59873 29.9106C3.69002 35.3872 0 43.2043 0 51.8872C0 53.9234 0.210191 55.8894 0.583864 57.8085C1.16773 60.734 3.73673 62.8638 6.72612 62.8638H53.2484C56.1911 62.8638 58.7367 60.8043 59.344 57.9489C59.6943 56.3106 59.9045 54.6021 59.9745 52.8702C60.2781 43.766 56.4947 35.5511 50.3758 29.8638"
          fill="#00416B"
        />
        <path
          d="M59.7651 58.3469C59.7651 63.1213 46.4296 66.983 29.988 66.983C13.5464 66.983 0.210938 63.1213 0.210938 58.3469C0.210938 53.5724 13.5464 49.7107 29.988 49.7107C46.4296 49.7107 59.7651 53.5724 59.7651 58.3469Z"
          fill="#00416B"
        />
        <path
          d="M34.7979 4.82128C34.7979 7.48936 32.6492 9.64255 29.9868 9.64255C27.3244 9.64255 25.1758 7.48936 25.1758 4.82128C25.1758 2.15319 27.3244 0 29.9868 0C32.6492 0 34.7979 2.15319 34.7979 4.82128Z"
          fill="#00416B"
        />
        <path
          d="M49.6294 35.3872C58.6711 35.3872 66.0009 28.0418 66.0009 18.9808C66.0009 9.91985 58.6711 2.57446 49.6294 2.57446C40.5876 2.57446 33.2578 9.91985 33.2578 18.9808C33.2578 28.0418 40.5876 35.3872 49.6294 35.3872Z"
          fill="#EAEDF8"
        />
        <path
          d="M51.7079 27.4532C51.7079 28.6 50.7971 29.5128 49.6527 29.5128C48.5083 29.5128 47.5508 28.6 47.5508 27.4532C47.5508 26.3064 48.485 25.3936 49.6527 25.3936C50.8204 25.3936 51.7079 26.3064 51.7079 27.4532ZM48.2748 23.966L47.5975 8.42554H51.6845L51.0073 23.966H48.2748Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1378">
          <rect width="66" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
